import ImportIllustration from '@public/nextjs/svgs/import-illustration-new.svg';
import { UploadDropZone as DropZone } from '@rpldy/upload-drop-zone';
import Image from 'next/image';
import { useCallback } from 'react';

export function UploadDropZone() {
  // Safari fix: Set dropEffect during drag to make drop zone work in Safari
  const shouldHandleDrag = useCallback((e: DragEvent) => {
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy';
    }
    return true;
  }, []);

  return (
    <DropZone
      className="flex flex-col items-center justify-center"
      shouldHandleDrag={shouldHandleDrag}
    >
      <div className="font-bold text-xl pointer-events-none">Drag & Drop</div>
      <div className="h-14 w-28 my-4 pointer-events-none">
        <Image
          src={ImportIllustration}
          width={112}
          height={56}
          className="h-full w-full object-fill pointer-events-none"
          alt="Drag & Drop"
        />
      </div>
      <div className="text-sm text-palette-gray-700 pointer-events-none">
        AAC, MP3, M4A, WAV, WMA
      </div>
      <div className="text-sm text-palette-gray-700 pointer-events-none">
        MOV, MPEG, MP4, WMV
      </div>
      <div className="text-sm text-palette-gray-400 mt-1 pointer-events-none">
        or
      </div>
    </DropZone>
  );
}
